<!-- jb-page-placeholder = 'jb-btn' -->

<h2>{{name}}</h2>
<hr/>
<h5>{{desc}}</h5>

<h5 class="mt-4">Parameters:</h5>
<div class="col-12"><pre>{{api}}</pre></div>

<hr>

<h5 class="mt-4">Examples:</h5>
<div class="row">
  <div class="col-4">
    <div class="whiteBg">
      <h5 class="marB25">jb-page-placeholder jbType="profile"</h5>
      <div class="code-box"><pre>{{instance}}</pre></div>
      <div class="row marT20">

        <div class="col-12 marB20"><jb-radio [(ngModel)]="profileExample.isSection" jbLabel="No Section" [jbValue]="false" (ngModelChange)="addSection()"></jb-radio></div>
        <div class="col-12 marB20"><jb-radio [(ngModel)]="profileExample.isSection" jbLabel="Section active" [jbValue]="true" (ngModelChange)="addSection()"></jb-radio></div>

        <div class="col-12 marB10" *ngIf="profileExample.isSection">
          <jb-checkbox [(ngModel)]="profileExample.hasAvatar" (ngModelChange)="upIns()" jbLabel="Avatar"></jb-checkbox>
        </div>
        <div class="col-12 marB10" *ngIf="profileExample.isSection">
          <jb-checkbox [(ngModel)]="profileExample.hasData" (ngModelChange)="upIns()" jbLabel="Data"></jb-checkbox>
        </div>
        <div class="col-12 marB10" *ngIf="profileExample.isSection">
          <jb-checkbox [(ngModel)]="profileExample.hasInfo" (ngModelChange)="upIns()" jbLabel="Info"></jb-checkbox>
        </div>
        <div class="col-12 marB10" *ngIf="profileExample.isSection">
          <jb-checkbox [(ngModel)]="profileExample.hasInfoCenter" (ngModelChange)="upIns()" jbLabel="Info Center"></jb-checkbox>
        </div>
      </div>
    </div>

    <jb-page-placeholder jbType="profile" [jbSections]="profileExample.sectionList"></jb-page-placeholder>
  </div>
  <div class="col-8">
    <div class="whiteBg">
      <div class="row">
        <div class="col-12 marB15">
          <h5 class="marB25">jb-page-placeholder jbType="details"</h5>
        </div>
        <div class="col-12 marB30"><div class="code-box pad5"><pre>{{instance2}}</pre></div></div>
        <div class="col-12 marB30"><div class="code-box pad5"><pre>{{instance3}}</pre></div></div>
      </div>
    </div>

    <jb-page-placeholder jbType="details"></jb-page-placeholder>
  </div>
</div>
<div class="row">
  <div class="col-4">
    <div class="whiteBg">
      <div class="row">
        <div class="col-12 marB15">
          <h5 class="marB25">jb-page-placeholder jbType="details" [jbTabs]="true"</h5>
        </div>
        <div class="col-12 marB30"><div class="code-box pad5"><pre>{{instance4}}</pre></div></div>
      </div>
    </div>
  </div>
  <div class="col-8">
    <div class="whiteBg" style="padding: 0px;">
      <ul class="nav nav-tabs marB20">
        <li class="nav-item" style="width: 25%; text-align: center; background: #00B6F1;">
          <h5 class="nav-link">Devices</h5>
        </li>
        <li class="nav-item" style="width: 25%; text-align: center; background: #00B6F1;">
          <h5 class="nav-link">User</h5>
        </li>
        <li class="nav-item" style="width: 25%; text-align: center; background: #00B6F1;">
          <h5 class="nav-link">Quotes</h5>
        </li>
        <li class="nav-item" style="width: 25%; text-align: center; background: #00B6F1;">
          <h5 class="nav-link">Customer</h5>
        </li>
      </ul>

      <div class="row" style="padding: 0 25px;">
        <div class="col-12">
          <jb-page-placeholder jbType="details" [jbTabs]="true"></jb-page-placeholder>
        </div>
      </div>
    </div>
  </div>
</div>


